import { Heart, Wifi, Video, MapPin } from 'lucide-react';
import { Spot } from '@/types/spots';
import { motion } from 'framer-motion';

interface SpotLargeCardProps {
  spot: Spot;
  isSelected?: boolean;
  onSelect: (spot: Spot) => void;
}

const SpotLargeCard = ({ spot, isSelected, onSelect }: SpotLargeCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={() => onSelect(spot)}
      className={`rounded-2xl overflow-hidden bg-accent/30 p-2 cursor-pointer transition-all ${
        isSelected ? 'ring-2 ring-primary' : ''
      }`}
    >
      {/* Image container */}
      <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
        <img
          src={spot.imageUrl || 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop'}
          alt={spot.name}
          className="w-full h-full object-cover"
        />
        {/* Favorite button */}
        <button
          className="absolute top-3 right-3 w-10 h-10 bg-background/80 backdrop-blur-sm rounded-full flex items-center justify-center"
          onClick={(e) => {
            e.stopPropagation();
            // TODO: Add to favorites
          }}
        >
          <Heart className="w-5 h-5 text-muted-foreground" />
        </button>
      </div>

      {/* Content */}
      <div className="pt-3 pb-1 px-1">
        <h3 className="font-semibold text-primary text-lg font-heading">
          {spot.name}
        </h3>
        <p className="text-muted-foreground text-sm mt-0.5">{spot.type}</p>
        
        {/* Features row */}
        <div className="flex items-center gap-4 mt-2">
          {spot.wifiQuality >= 4 && (
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <Wifi className="w-4 h-4" />
              <span className="text-sm">Fast WiFi</span>
            </div>
          )}
          {spot.callFriendly && (
            <div className="flex items-center gap-1.5 text-primary">
              <Video className="w-4 h-4" />
              <span className="text-sm">Calls-friendly</span>
            </div>
          )}
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <MapPin className="w-4 h-4" />
            <span className="text-sm">0.3 mi</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SpotLargeCard;
